<template>
  <div class="container pb-10 flex justify-between items-center gap-9">
    <div>
      <h1 class="mb-6" v-html="$tt('blog.header')" />
      <p class="lead">
        <strong v-html="$tt('blog.subheader')" />
      </p>
      <p class="lead pb-3">
        {{ $tt('blog.description') }}
      </p>
    </div>
    <AppImg src="/images/man-reading-newspaper.jpg" :alt="$tt('blog.hero_img')" />
  </div>
</template>

<style scoped>
@media (max-width: 850px) {
  .container {
    padding-bottom: var(--space-5) !important;
    flex-direction: column-reverse;
    gap: var(--space-6);
    text-align: center;
  }
  h1 {
    font-size: 34px;
  }
  p {
    line-height: var(--lh-md);
  }
  img {
    width: 85%;
  }
}
</style>